import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { usePriceComponents } from "@/components/Sections/Price/hooks/usePriceComponents";
import { Section, Title } from "@/components/UI";
import { useRefsContext } from "@/contexts/ref";
import { useClassified } from "@/contexts/classified";
import { Box } from "@gemini/core";
import { useI18n } from "@/shared/hooks";
import { PriceComponents } from "./PriceComponents";
export const priceTestId = "cdp-price";
export const Price = () => {
    var _a, _b;
    const components = usePriceComponents();
    const isRent = ((_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.tracking) === null || _b === void 0 ? void 0 : _b.av_distribution_type_global) === "1";
    const { priceRef } = useRefsContext();
    const { t } = useI18n();
    const title = isRent ? t("price.title_rent") : t("price.title_buy");
    return (components === null || components === void 0 ? void 0 : components.length) ? (_jsxs(Section, { ref: priceRef, hasDivider: true, testId: priceTestId, children: [_jsx(Title, { variant: "section", title: title, id: "price" }), _jsx(PriceComponents, {}), _jsx(Box, { display: "grid", gridTemplateColumns: {
                    "breakpoint.base": "repeat(1, 1fr)",
                }, gap: "spacing.none" })] })) : null;
};
